import classNames from 'classnames'
import * as React from 'react'
import { Nav } from 'reactstrap'
import { INavTabItemProps } from './NavTabItem'

export interface INavTabsProps {
  children:
    | React.ReactElement<INavTabItemProps>
    | Array<React.ReactElement<INavTabItemProps> | null>
  className?: string
  style?: React.CSSProperties
}

export class NavTabs extends React.PureComponent<INavTabsProps> {
  public render() {
    return (
      <Nav
        className={classNames('d-print-none', this.props.className)}
        style={this.props.style}
        tabs
      >
        {this.props.children}
      </Nav>
    )
  }
}
